import { Injectable, inject } from '@angular/core';
import { HTTP_AP_CloseMortgage_Request } from '@api-new/mortgageservice/HTTP_AP_CloseMortgage_Request';
import { HTTP_AP_CompanyMortgageComparisonSettings } from '@api-new/mortgageservice/HTTP_AP_CompanyMortgageComparisonSettings';
import { HTTP_AP_CompanyMortgageSettings } from '@api-new/mortgageservice/HTTP_AP_CompanyMortgageSettings';
import { HTTP_AP_CompanyPreCompletionComparisonSettings } from '@api-new/mortgageservice/HTTP_AP_CompanyPreCompletionComparisonSettings';
import { HTTP_AP_CreateLenderGroup_Request } from '@api-new/mortgageservice/HTTP_AP_CreateLenderGroup_Request';
import { HTTP_AP_CreateMortgage_Request } from '@api-new/mortgageservice/HTTP_AP_CreateMortgage_Request';
import { HTTP_AP_DeleteLenderGroup_Request } from '@api-new/mortgageservice/HTTP_AP_DeleteLenderGroup_Request';
import { HTTP_AP_ExportCompanyMortgages_Request } from '@api-new/mortgageservice/HTTP_AP_ExportCompanyMortgages_Request';
import { HTTP_AP_GetCompanyMortgageComparisonSettings_ForLenders_Request } from '@api-new/mortgageservice/HTTP_AP_GetCompanyMortgageComparisonSettings_ForLenders_Request';
import { HTTP_AP_GetCompanyMortgageComparisonSettings_ForLenders_Response } from '@api-new/mortgageservice/HTTP_AP_GetCompanyMortgageComparisonSettings_ForLenders_Response';
import { HTTP_AP_GetCompanyMortgageComparisonSettings_Request } from '@api-new/mortgageservice/HTTP_AP_GetCompanyMortgageComparisonSettings_Request';
import { HTTP_AP_GetCompanyMortgageSettings_Request } from '@api-new/mortgageservice/HTTP_AP_GetCompanyMortgageSettings_Request';
import { HTTP_AP_GetCompanyPreCompletionComparisonSettings_Request } from '@api-new/mortgageservice/HTTP_AP_GetCompanyPreCompletionComparisonSettings_Request';
import { HTTP_AP_GetLenderDefaultErcs_ForLenderDetail_Request } from '@api-new/mortgageservice/HTTP_AP_GetLenderDefaultErcs_ForLenderDetail_Request';
import { HTTP_AP_GetLenderGroup_Request } from '@api-new/mortgageservice/HTTP_AP_GetLenderGroup_Request';
import { HTTP_AP_GetLender_ForLenderDetail_Request } from '@api-new/mortgageservice/HTTP_AP_GetLender_ForLenderDetail_Request';
import { HTTP_AP_GetLender_ForLenderDetail_Response } from '@api-new/mortgageservice/HTTP_AP_GetLender_ForLenderDetail_Response';
import { HTTP_AP_GetLender_Request } from '@api-new/mortgageservice/HTTP_AP_GetLender_Request';
import { HTTP_AP_GetMortgageComparisonSettings_ForAdvisorDealRejection_Request } from '@api-new/mortgageservice/HTTP_AP_GetMortgageComparisonSettings_ForAdvisorDealRejection_Request';
import { HTTP_AP_GetMortgageComparisonSettings_ForAdvisorDealRejection_Response } from '@api-new/mortgageservice/HTTP_AP_GetMortgageComparisonSettings_ForAdvisorDealRejection_Response';
import { HTTP_AP_GetMortgageProduct_Request } from '@api-new/mortgageservice/HTTP_AP_GetMortgageProduct_Request';
import { HTTP_AP_GetMortgageProduct_Response } from '@api-new/mortgageservice/HTTP_AP_GetMortgageProduct_Response';
import { HTTP_AP_GetMortgage_ForComparison_Request } from '@api-new/mortgageservice/HTTP_AP_GetMortgage_ForComparison_Request';
import { HTTP_AP_GetMortgage_ForComparison_Response } from '@api-new/mortgageservice/HTTP_AP_GetMortgage_ForComparison_Response';
import { HTTP_AP_GetMortgage_ForMortgageDetail_Request } from '@api-new/mortgageservice/HTTP_AP_GetMortgage_ForMortgageDetail_Request';
import { HTTP_AP_GetNetworkMortgageComparisonSettings_ForLenders_Request } from '@api-new/mortgageservice/HTTP_AP_GetNetworkMortgageComparisonSettings_ForLenders_Request';
import { HTTP_AP_GetNetworkMortgageComparisonSettings_ForLenders_Response } from '@api-new/mortgageservice/HTTP_AP_GetNetworkMortgageComparisonSettings_ForLenders_Response';
import { HTTP_AP_GetPreCompletionComparisonSettings_Request } from '@api-new/mortgageservice/HTTP_AP_GetPreCompletionComparisonSettings_Request';
import { HTTP_AP_GetPreCompletionComparisonSettings_Response } from '@api-new/mortgageservice/HTTP_AP_GetPreCompletionComparisonSettings_Response';
import { HTTP_AP_GetPreCompletion_ForComparison_Request } from '@api-new/mortgageservice/HTTP_AP_GetPreCompletion_ForComparison_Request';
import { HTTP_AP_GetPreCompletion_ForComparison_Response } from '@api-new/mortgageservice/HTTP_AP_GetPreCompletion_ForComparison_Response';
import { HTTP_AP_GetPreCompletion_ForDetail_Request } from '@api-new/mortgageservice/HTTP_AP_GetPreCompletion_ForDetail_Request';
import { HTTP_AP_GetPreCompletion_ForDetail_Response } from '@api-new/mortgageservice/HTTP_AP_GetPreCompletion_ForDetail_Response';
import { HTTP_AP_GetSmartSearch_ForComparison_Request } from '@api-new/mortgageservice/HTTP_AP_GetSmartSearch_ForComparison_Request';
import { HTTP_AP_GetSmartSearch_ForComparison_Response } from '@api-new/mortgageservice/HTTP_AP_GetSmartSearch_ForComparison_Response';
import { HTTP_AP_Lender } from '@api-new/mortgageservice/HTTP_AP_Lender';
import { HTTP_AP_LenderDefaultErcs_ForLenderDetail } from '@api-new/mortgageservice/HTTP_AP_LenderDefaultErcs_ForLenderDetail';
import { HTTP_AP_LenderGroup } from '@api-new/mortgageservice/HTTP_AP_LenderGroup';
import { HTTP_AP_ListDeals_ForComparison_Request } from '@api-new/mortgageservice/HTTP_AP_ListDeals_ForComparison_Request';
import { HTTP_AP_ListDeals_ForComparison_Response } from '@api-new/mortgageservice/HTTP_AP_ListDeals_ForComparison_Response';
import { HTTP_AP_ListLenderCriteria_ForLenderDetail_Request } from '@api-new/mortgageservice/HTTP_AP_ListLenderCriteria_ForLenderDetail_Request';
import { HTTP_AP_ListLenderCriteria_ForLenderDetail_Response } from '@api-new/mortgageservice/HTTP_AP_ListLenderCriteria_ForLenderDetail_Response';
import { HTTP_AP_ListLenderGroups_ForSelect_Response } from '@api-new/mortgageservice/HTTP_AP_ListLenderGroups_ForSelect_Response';
import { HTTP_AP_ListLenderGroups_ForTable_Request } from '@api-new/mortgageservice/HTTP_AP_ListLenderGroups_ForTable_Request';
import { HTTP_AP_ListLenderGroups_ForTable_Response } from '@api-new/mortgageservice/HTTP_AP_ListLenderGroups_ForTable_Response';
import { HTTP_AP_ListLenderSvrs_ForLenderDetail_Request } from '@api-new/mortgageservice/HTTP_AP_ListLenderSvrs_ForLenderDetail_Request';
import { HTTP_AP_ListLenderSvrs_ForLenderDetail_Response } from '@api-new/mortgageservice/HTTP_AP_ListLenderSvrs_ForLenderDetail_Response';
import { HTTP_AP_ListLenders_ForTable_Request } from '@api-new/mortgageservice/HTTP_AP_ListLenders_ForTable_Request';
import { HTTP_AP_ListLenders_ForTable_Response } from '@api-new/mortgageservice/HTTP_AP_ListLenders_ForTable_Response';
import { HTTP_AP_ListMortgageBorrowers_Request } from '@api-new/mortgageservice/HTTP_AP_ListMortgageBorrowers_Request';
import { HTTP_AP_ListMortgageBorrowers_Response } from '@api-new/mortgageservice/HTTP_AP_ListMortgageBorrowers_Response';
import { HTTP_AP_ListMortgageProducts_ForTable_Request } from '@api-new/mortgageservice/HTTP_AP_ListMortgageProducts_ForTable_Request';
import { HTTP_AP_ListMortgageProducts_ForTable_Response } from '@api-new/mortgageservice/HTTP_AP_ListMortgageProducts_ForTable_Response';
import { HTTP_AP_ListMortgages_ForTable_Request } from '@api-new/mortgageservice/HTTP_AP_ListMortgages_ForTable_Request';
import { HTTP_AP_ListMortgages_ForTable_Response } from '@api-new/mortgageservice/HTTP_AP_ListMortgages_ForTable_Response';
import { HTTP_AP_ListPreCompletions_ForTable_Request } from '@api-new/mortgageservice/HTTP_AP_ListPreCompletions_ForTable_Request';
import { HTTP_AP_ListPreCompletions_ForTable_Response } from '@api-new/mortgageservice/HTTP_AP_ListPreCompletions_ForTable_Response';
import { HTTP_AP_MatchMortgageProducts_Request } from '@api-new/mortgageservice/HTTP_AP_MatchMortgageProducts_Request';
import { HTTP_AP_MatchMortgageProducts_Response } from '@api-new/mortgageservice/HTTP_AP_MatchMortgageProducts_Response';
import { HTTP_AP_Mortgage } from '@api-new/mortgageservice/HTTP_AP_Mortgage';
import { HTTP_AP_MortgageComparisonSettings } from '@api-new/mortgageservice/HTTP_AP_MortgageComparisonSettings';
import { HTTP_AP_ResumeMortgageCaseCreation_Request } from '@api-new/mortgageservice/HTTP_AP_ResumeMortgageCaseCreation_Request';
import { HTTP_AP_SetCompanyExcludedLenders_Request } from '@api-new/mortgageservice/HTTP_AP_SetCompanyExcludedLenders_Request';
import { HTTP_AP_SetMortgageReview_Request } from '@api-new/mortgageservice/HTTP_AP_SetMortgageReview_Request';
import { HTTP_AP_SetNetworkExcludedLenders_Request } from '@api-new/mortgageservice/HTTP_AP_SetNetworkExcludedLenders_Request';
import { HTTP_AP_UpdateCompanyMortgageComparisonSettings_Request } from '@api-new/mortgageservice/HTTP_AP_UpdateCompanyMortgageComparisonSettings_Request';
import { HTTP_AP_UpdateCompanyMortgageSettings_Request } from '@api-new/mortgageservice/HTTP_AP_UpdateCompanyMortgageSettings_Request';
import { HTTP_AP_UpdateCompanyPreCompletionComparisonSettings_Request } from '@api-new/mortgageservice/HTTP_AP_UpdateCompanyPreCompletionComparisonSettings_Request';
import { HTTP_AP_UpdateLenderDefaultErcs_Request } from '@api-new/mortgageservice/HTTP_AP_UpdateLenderDefaultErcs_Request';
import { HTTP_AP_UpdateLenderGroup_Request } from '@api-new/mortgageservice/HTTP_AP_UpdateLenderGroup_Request';
import { HTTP_AP_UpdateLenderLogo_Request } from '@api-new/mortgageservice/HTTP_AP_UpdateLenderLogo_Request';
import { HTTP_AP_UpdateLenderLogo_Response } from '@api-new/mortgageservice/HTTP_AP_UpdateLenderLogo_Response';
import { HTTP_AP_UpdateMortgageComparisonSettings_Request } from '@api-new/mortgageservice/HTTP_AP_UpdateMortgageComparisonSettings_Request';
import { HTTP_AP_UpdateMortgage_ForIrregularPayments_Request } from '@api-new/mortgageservice/HTTP_AP_UpdateMortgage_ForIrregularPayments_Request';
import { HTTP_AP_UpdateMortgage_Request } from '@api-new/mortgageservice/HTTP_AP_UpdateMortgage_Request';
import { HTTP_AP_UpdatePreCompletionComparisonSettings_Request } from '@api-new/mortgageservice/HTTP_AP_UpdatePreCompletionComparisonSettings_Request';
import { HTTP_AP_UpdatePreCompletionComparisonSettings_Response } from '@api-new/mortgageservice/HTTP_AP_UpdatePreCompletionComparisonSettings_Response';
import { HTTP_CP_CloseMortgage_Request } from '@api-new/mortgageservice/HTTP_CP_CloseMortgage_Request';
import { HTTP_CP_CloseSmartSearch_Request } from '@api-new/mortgageservice/HTTP_CP_CloseSmartSearch_Request';
import { HTTP_CP_CreateMortgage_Request } from '@api-new/mortgageservice/HTTP_CP_CreateMortgage_Request';
import { HTTP_CP_CreateSmartSearch_Request } from '@api-new/mortgageservice/HTTP_CP_CreateSmartSearch_Request';
import { HTTP_CP_GetDashboardData_Response } from '@api-new/mortgageservice/HTTP_CP_GetDashboardData_Response';
import { HTTP_CP_GetMortgageAmortizationTable_Request } from '@api-new/mortgageservice/HTTP_CP_GetMortgageAmortizationTable_Request';
import { HTTP_CP_GetMortgageAmortizationTable_Response } from '@api-new/mortgageservice/HTTP_CP_GetMortgageAmortizationTable_Response';
import { HTTP_CP_GetMortgageDealAmortizationTable_Request } from '@api-new/mortgageservice/HTTP_CP_GetMortgageDealAmortizationTable_Request';
import { HTTP_CP_GetMortgageDealAmortizationTable_Response } from '@api-new/mortgageservice/HTTP_CP_GetMortgageDealAmortizationTable_Response';
import { HTTP_CP_GetMortgageDealComparison_Request } from '@api-new/mortgageservice/HTTP_CP_GetMortgageDealComparison_Request';
import { HTTP_CP_GetMortgageDealComparison_Response } from '@api-new/mortgageservice/HTTP_CP_GetMortgageDealComparison_Response';
import { HTTP_CP_GetMortgageDealRepresentativeExample_Request } from '@api-new/mortgageservice/HTTP_CP_GetMortgageDealRepresentativeExample_Request';
import { HTTP_CP_GetMortgageDealRepresentativeExample_Response } from '@api-new/mortgageservice/HTTP_CP_GetMortgageDealRepresentativeExample_Response';
import { HTTP_CP_GetSmartSearchDealRepresentativeExample_Request } from '@api-new/mortgageservice/HTTP_CP_GetSmartSearchDealRepresentativeExample_Request';
import { HTTP_CP_GetSmartSearchDealRepresentativeExample_Response } from '@api-new/mortgageservice/HTTP_CP_GetSmartSearchDealRepresentativeExample_Response';
import { HTTP_CP_ListMortgageDeals_Request } from '@api-new/mortgageservice/HTTP_CP_ListMortgageDeals_Request';
import { HTTP_CP_ListMortgageDeals_Response } from '@api-new/mortgageservice/HTTP_CP_ListMortgageDeals_Response';
import { HTTP_CP_ListMortgages_Response } from '@api-new/mortgageservice/HTTP_CP_ListMortgages_Response';
import { HTTP_CP_ListSmartSearchDeals_Request } from '@api-new/mortgageservice/HTTP_CP_ListSmartSearchDeals_Request';
import { HTTP_CP_ListSmartSearchDeals_Response } from '@api-new/mortgageservice/HTTP_CP_ListSmartSearchDeals_Response';
import { HTTP_CP_ListSmartSearches_Response } from '@api-new/mortgageservice/HTTP_CP_ListSmartSearches_Response';
import { HTTP_CP_MatchMortgageProducts_Request } from '@api-new/mortgageservice/HTTP_CP_MatchMortgageProducts_Request';
import { HTTP_CP_MatchMortgageProducts_Response } from '@api-new/mortgageservice/HTTP_CP_MatchMortgageProducts_Response';
import { HTTP_CP_Mortgage } from '@api-new/mortgageservice/HTTP_CP_Mortgage';
import { HTTP_CP_MortgageComparisonSettings } from '@api-new/mortgageservice/HTTP_CP_MortgageComparisonSettings';
import { HTTP_CP_SmartSearch } from '@api-new/mortgageservice/HTTP_CP_SmartSearch';
import { HTTP_CP_UpdateMortgageComparisonSettings_Request } from '@api-new/mortgageservice/HTTP_CP_UpdateMortgageComparisonSettings_Request';
import { HTTP_CP_UpdateMortgage_ForIrregularPayments_Request } from '@api-new/mortgageservice/HTTP_CP_UpdateMortgage_ForIrregularPayments_Request';
import { HTTP_CP_UpdateSmartSearch_Request } from '@api-new/mortgageservice/HTTP_CP_UpdateSmartSearch_Request';
import { HTTP_X_CalculateInterestRate_ForFullRepayment_Request } from '@api-new/mortgageservice/HTTP_X_CalculateInterestRate_ForFullRepayment_Request';
import { HTTP_X_CalculateInterestRate_ForFullRepayment_Response } from '@api-new/mortgageservice/HTTP_X_CalculateInterestRate_ForFullRepayment_Response';
import { HTTP_X_CalculateInterestRate_ForInterestOnlyRepayment_Request } from '@api-new/mortgageservice/HTTP_X_CalculateInterestRate_ForInterestOnlyRepayment_Request';
import { HTTP_X_CalculateInterestRate_ForInterestOnlyRepayment_Response } from '@api-new/mortgageservice/HTTP_X_CalculateInterestRate_ForInterestOnlyRepayment_Response';
import { HTTP_X_CalculateMonthlyPayments_Request } from '@api-new/mortgageservice/HTTP_X_CalculateMonthlyPayments_Request';
import { HTTP_X_CalculateMonthlyPayments_Response } from '@api-new/mortgageservice/HTTP_X_CalculateMonthlyPayments_Response';
import { HTTP_X_CalculatePayMortgageFasterSavings_Request } from '@api-new/mortgageservice/HTTP_X_CalculatePayMortgageFasterSavings_Request';
import { HTTP_X_CalculatePayMortgageFasterSavings_Response } from '@api-new/mortgageservice/HTTP_X_CalculatePayMortgageFasterSavings_Response';
import { HTTP_X_CompareMortgageProducts_Request } from '@api-new/mortgageservice/HTTP_X_CompareMortgageProducts_Request';
import { HTTP_X_CompareMortgageProducts_Response } from '@api-new/mortgageservice/HTTP_X_CompareMortgageProducts_Response';
import { HTTP_X_GetMortgageProductRepresentativeExample_Request } from '@api-new/mortgageservice/HTTP_X_GetMortgageProductRepresentativeExample_Request';
import { HTTP_X_GetMortgageProductRepresentativeExample_Response } from '@api-new/mortgageservice/HTTP_X_GetMortgageProductRepresentativeExample_Response';
import { HTTP_X_ListLenders_Request } from '@api-new/mortgageservice/HTTP_X_ListLenders_Request';
import { HTTP_X_ListLenders_Response } from '@api-new/mortgageservice/HTTP_X_ListLenders_Response';
import { Observable } from 'rxjs';
import { ApplicationHttpClient, IRequestOptions } from '../../../../../lib/services/application-http.service';

@Injectable({ providedIn: 'root' })
export class MortgageApiService {
  private readonly httpClient = inject(ApplicationHttpClient);

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- GRPC Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // --- HTTP Endpoints - Adviser Portal (ap) ------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_AP_CloseMortgage(request: HTTP_AP_CloseMortgage_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/mortgage-service/ap/CloseMortgage`, request, options);
  }

  HTTP_AP_CreateLenderGroup(request: HTTP_AP_CreateLenderGroup_Request, options?: IRequestOptions): Observable<HTTP_AP_LenderGroup> {
    return this.httpClient.post(`/mortgage-service/ap/CreateLenderGroup`, request, options);
  }

  HTTP_AP_CreateMortgage(request: HTTP_AP_CreateMortgage_Request, options?: IRequestOptions): Observable<HTTP_AP_Mortgage> {
    return this.httpClient.post(`/mortgage-service/ap/CreateMortgage`, request, options);
  }

  HTTP_AP_DeleteLenderGroup(request: HTTP_AP_DeleteLenderGroup_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.delete(`/mortgage-service/ap/DeleteLenderGroup`, { params: request });
  }

  HTTP_AP_ExportCompanyMortgages(request: HTTP_AP_ExportCompanyMortgages_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/mortgage-service/ap/ExportCompanyMortgages`, request, options);
  }

  HTTP_AP_GetCompanyMortgageComparisonSettings(
    request: HTTP_AP_GetCompanyMortgageComparisonSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanyMortgageComparisonSettings> {
    return this.httpClient.get(`/mortgage-service/ap/GetCompanyMortgageComparisonSettings`, { params: request });
  }

  HTTP_AP_GetCompanyMortgageComparisonSettings_ForLenders(
    request: HTTP_AP_GetCompanyMortgageComparisonSettings_ForLenders_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetCompanyMortgageComparisonSettings_ForLenders_Response> {
    return this.httpClient.get(`/mortgage-service/ap/GetCompanyMortgageComparisonSettings_ForLenders`, { params: request });
  }

  HTTP_AP_GetCompanyMortgageSettings(
    request: HTTP_AP_GetCompanyMortgageSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanyMortgageSettings> {
    return this.httpClient.get(`/mortgage-service/ap/GetCompanyMortgageSettings`, { params: request });
  }

  HTTP_AP_GetCompanyPreCompletionComparisonSettings(
    request: HTTP_AP_GetCompanyPreCompletionComparisonSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanyPreCompletionComparisonSettings> {
    return this.httpClient.get(`/mortgage-service/ap/GetCompanyPreCompletionComparisonSettings`, { params: request });
  }

  HTTP_AP_GetLender(request: HTTP_AP_GetLender_Request, options?: IRequestOptions): Observable<HTTP_AP_Lender> {
    return this.httpClient.get(`/mortgage-service/ap/GetLender`, { params: request });
  }

  HTTP_AP_GetLender_ForLenderDetail(
    request: HTTP_AP_GetLender_ForLenderDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetLender_ForLenderDetail_Response> {
    return this.httpClient.get(`/mortgage-service/ap/GetLender_ForLenderDetail`, { params: request });
  }

  HTTP_AP_GetLenderDefaultErcs_ForLenderDetail(
    request: HTTP_AP_GetLenderDefaultErcs_ForLenderDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_LenderDefaultErcs_ForLenderDetail> {
    return this.httpClient.get(`/mortgage-service/ap/GetLenderDefaultErcs_ForLenderDetail`, { params: request });
  }

  HTTP_AP_GetLenderGroup(request: HTTP_AP_GetLenderGroup_Request, options?: IRequestOptions): Observable<HTTP_AP_LenderGroup> {
    return this.httpClient.get(`/mortgage-service/ap/GetLenderGroup`, { params: request });
  }

  HTTP_AP_GetMortgage_ForComparison(
    request: HTTP_AP_GetMortgage_ForComparison_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetMortgage_ForComparison_Response> {
    return this.httpClient.get(`/mortgage-service/ap/GetMortgage_ForComparison`, { params: request });
  }

  HTTP_AP_GetMortgage_ForMortgageDetail(
    request: HTTP_AP_GetMortgage_ForMortgageDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_Mortgage> {
    return this.httpClient.get(`/mortgage-service/ap/GetMortgage_ForMortgageDetail`, { params: request });
  }

  HTTP_AP_GetMortgageComparisonSettings_ForAdvisorDealRejection(
    request: HTTP_AP_GetMortgageComparisonSettings_ForAdvisorDealRejection_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetMortgageComparisonSettings_ForAdvisorDealRejection_Response> {
    return this.httpClient.get(`/mortgage-service/ap/GetMortgageComparisonSettings_ForAdvisorDealRejection`, { params: request });
  }

  HTTP_AP_GetMortgageProduct(
    request: HTTP_AP_GetMortgageProduct_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetMortgageProduct_Response> {
    return this.httpClient.get(`/mortgage-service/ap/GetMortgageProduct`, { params: request });
  }

  HTTP_AP_GetNetworkMortgageComparisonSettings_ForLenders(
    request: HTTP_AP_GetNetworkMortgageComparisonSettings_ForLenders_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetNetworkMortgageComparisonSettings_ForLenders_Response> {
    return this.httpClient.get(`/mortgage-service/ap/GetNetworkMortgageComparisonSettings_ForLenders`, { params: request });
  }

  HTTP_AP_GetPreCompletion_ForComparison(
    request: HTTP_AP_GetPreCompletion_ForComparison_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetPreCompletion_ForComparison_Response> {
    return this.httpClient.get(`/mortgage-service/ap/GetPreCompletion_ForComparison`, { params: request });
  }

  HTTP_AP_GetPreCompletion_ForDetail(
    request: HTTP_AP_GetPreCompletion_ForDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetPreCompletion_ForDetail_Response> {
    return this.httpClient.get(`/mortgage-service/ap/GetPreCompletion_ForDetail`, { params: request });
  }

  HTTP_AP_GetPreCompletionComparisonSettings(
    request: HTTP_AP_GetPreCompletionComparisonSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetPreCompletionComparisonSettings_Response> {
    return this.httpClient.get(`/mortgage-service/ap/GetPreCompletionComparisonSettings`, { params: request });
  }

  HTTP_AP_GetSmartSearch_ForComparison(
    request: HTTP_AP_GetSmartSearch_ForComparison_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetSmartSearch_ForComparison_Response> {
    return this.httpClient.get(`/mortgage-service/ap/GetSmartSearch_ForComparison`, { params: request });
  }

  HTTP_AP_ListDeals_ForComparison(
    request: HTTP_AP_ListDeals_ForComparison_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListDeals_ForComparison_Response> {
    return this.httpClient.get(`/mortgage-service/ap/ListDeals_ForComparison`, { params: request });
  }

  HTTP_AP_ListLenderCriteria_ForLenderDetail(
    request: HTTP_AP_ListLenderCriteria_ForLenderDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListLenderCriteria_ForLenderDetail_Response> {
    return this.httpClient.get(`/mortgage-service/ap/ListLenderCriteria_ForLenderDetail`, { params: request });
  }

  HTTP_AP_ListLenderGroups_ForSelect(
    request?: undefined,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListLenderGroups_ForSelect_Response> {
    return this.httpClient.get(`/mortgage-service/ap/ListLenderGroups_ForSelect`, { params: request });
  }

  HTTP_AP_ListLenderGroups_ForTable(
    request: HTTP_AP_ListLenderGroups_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListLenderGroups_ForTable_Response> {
    return this.httpClient.get(`/mortgage-service/ap/ListLenderGroups_ForTable`, { params: request });
  }

  HTTP_AP_ListLenders_ForTable(
    request: HTTP_AP_ListLenders_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListLenders_ForTable_Response> {
    return this.httpClient.get(`/mortgage-service/ap/ListLenders_ForTable`, { params: request });
  }

  HTTP_AP_ListLenderSvrs_ForLenderDetail(
    request: HTTP_AP_ListLenderSvrs_ForLenderDetail_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListLenderSvrs_ForLenderDetail_Response> {
    return this.httpClient.get(`/mortgage-service/ap/ListLenderSvrs_ForLenderDetail`, { params: request });
  }

  HTTP_AP_ListMortgageBorrowers(
    request: HTTP_AP_ListMortgageBorrowers_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListMortgageBorrowers_Response> {
    return this.httpClient.get(`/mortgage-service/ap/ListMortgageBorrowers`, { params: request });
  }

  HTTP_AP_ListMortgageProducts_ForTable(
    request: HTTP_AP_ListMortgageProducts_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListMortgageProducts_ForTable_Response> {
    return this.httpClient.get(`/mortgage-service/ap/ListMortgageProducts_ForTable`, { params: request });
  }

  HTTP_AP_ListMortgages_ForTable(
    request: HTTP_AP_ListMortgages_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListMortgages_ForTable_Response> {
    return this.httpClient.get(`/mortgage-service/ap/ListMortgages_ForTable`, { params: request });
  }

  HTTP_AP_ListPreCompletions_ForTable(
    request: HTTP_AP_ListPreCompletions_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListPreCompletions_ForTable_Response> {
    return this.httpClient.get(`/mortgage-service/ap/ListPreCompletions_ForTable`, { params: request });
  }

  HTTP_AP_MatchMortgageProducts(
    request: HTTP_AP_MatchMortgageProducts_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_MatchMortgageProducts_Response> {
    return this.httpClient.post(`/mortgage-service/ap/MatchMortgageProducts`, request, options);
  }

  HTTP_AP_ResumeMortgageCaseCreation(
    request: HTTP_AP_ResumeMortgageCaseCreation_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.post(`/mortgage-service/ap/ResumeMortgageCaseCreation`, request, options);
  }

  HTTP_AP_SetCompanyExcludedLenders(request: HTTP_AP_SetCompanyExcludedLenders_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/mortgage-service/ap/SetCompanyExcludedLenders`, request, options);
  }

  HTTP_AP_SetMortgageReview(request: HTTP_AP_SetMortgageReview_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/mortgage-service/ap/SetMortgageReview`, request, options);
  }

  HTTP_AP_SetNetworkExcludedLenders(request: HTTP_AP_SetNetworkExcludedLenders_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/mortgage-service/ap/SetNetworkExcludedLenders`, request, options);
  }

  HTTP_AP_UpdateCompanyMortgageComparisonSettings(
    request: HTTP_AP_UpdateCompanyMortgageComparisonSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanyMortgageComparisonSettings> {
    return this.httpClient.put(`/mortgage-service/ap/UpdateCompanyMortgageComparisonSettings`, request, options);
  }

  HTTP_AP_UpdateCompanyMortgageSettings(
    request: HTTP_AP_UpdateCompanyMortgageSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanyMortgageSettings> {
    return this.httpClient.put(`/mortgage-service/ap/UpdateCompanyMortgageSettings`, request, options);
  }

  HTTP_AP_UpdateCompanyPreCompletionComparisonSettings(
    request: HTTP_AP_UpdateCompanyPreCompletionComparisonSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanyPreCompletionComparisonSettings> {
    return this.httpClient.put(`/mortgage-service/ap/UpdateCompanyPreCompletionComparisonSettings`, request, options);
  }

  HTTP_AP_UpdateLenderDefaultErcs(
    request: HTTP_AP_UpdateLenderDefaultErcs_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_LenderDefaultErcs_ForLenderDetail> {
    return this.httpClient.put(`/mortgage-service/ap/UpdateLenderDefaultErcs`, request, options);
  }

  HTTP_AP_UpdateLenderGroup(request: HTTP_AP_UpdateLenderGroup_Request, options?: IRequestOptions): Observable<HTTP_AP_LenderGroup> {
    return this.httpClient.patch(`/mortgage-service/ap/UpdateLenderGroup`, request, options);
  }

  HTTP_AP_UpdateLenderLogo(
    request: HTTP_AP_UpdateLenderLogo_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_UpdateLenderLogo_Response> {
    return this.httpClient.patch(`/mortgage-service/ap/UpdateLenderLogo`, request, options);
  }

  HTTP_AP_UpdateMortgage(request: HTTP_AP_UpdateMortgage_Request, options?: IRequestOptions): Observable<HTTP_AP_Mortgage> {
    return this.httpClient.put(`/mortgage-service/ap/UpdateMortgage`, request, options);
  }

  HTTP_AP_UpdateMortgage_ForIrregularPayments(
    request: HTTP_AP_UpdateMortgage_ForIrregularPayments_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_Mortgage> {
    return this.httpClient.put(`/mortgage-service/ap/UpdateMortgage_ForIrregularPayments`, request, options);
  }

  HTTP_AP_UpdateMortgageComparisonSettings(
    request: HTTP_AP_UpdateMortgageComparisonSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_MortgageComparisonSettings> {
    return this.httpClient.put(`/mortgage-service/ap/UpdateMortgageComparisonSettings`, request, options);
  }

  HTTP_AP_UpdatePreCompletionComparisonSettings(
    request: HTTP_AP_UpdatePreCompletionComparisonSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_UpdatePreCompletionComparisonSettings_Response> {
    return this.httpClient.put(`/mortgage-service/ap/UpdatePreCompletionComparisonSettings`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Client Portal (cp) -------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_CP_CloseMortgage(request: HTTP_CP_CloseMortgage_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/mortgage-service/cp/CloseMortgage`, request, options);
  }

  HTTP_CP_CloseSmartSearch(request: HTTP_CP_CloseSmartSearch_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.post(`/mortgage-service/cp/CloseSmartSearch`, request, options);
  }

  HTTP_CP_CreateMortgage(request: HTTP_CP_CreateMortgage_Request, options?: IRequestOptions): Observable<HTTP_CP_Mortgage> {
    return this.httpClient.post(`/mortgage-service/cp/CreateMortgage`, request, options);
  }

  HTTP_CP_CreateSmartSearch(request: HTTP_CP_CreateSmartSearch_Request, options?: IRequestOptions): Observable<HTTP_CP_SmartSearch> {
    return this.httpClient.post(`/mortgage-service/cp/CreateSmartSearch`, request, options);
  }

  HTTP_CP_GetDashboardData(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_GetDashboardData_Response> {
    return this.httpClient.get(`/mortgage-service/cp/GetDashboardData`, { params: request });
  }

  HTTP_CP_GetMortgageAmortizationTable(
    request: HTTP_CP_GetMortgageAmortizationTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_GetMortgageAmortizationTable_Response> {
    return this.httpClient.get(`/mortgage-service/cp/GetMortgageAmortizationTable`, { params: request });
  }

  HTTP_CP_GetMortgageDealAmortizationTable(
    request: HTTP_CP_GetMortgageDealAmortizationTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_GetMortgageDealAmortizationTable_Response> {
    return this.httpClient.get(`/mortgage-service/cp/GetMortgageDealAmortizationTable`, { params: request });
  }

  HTTP_CP_GetMortgageDealComparison(
    request: HTTP_CP_GetMortgageDealComparison_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_GetMortgageDealComparison_Response> {
    return this.httpClient.get(`/mortgage-service/cp/GetMortgageDealComparison`, { params: request });
  }

  HTTP_CP_GetMortgageDealRepresentativeExample(
    request: HTTP_CP_GetMortgageDealRepresentativeExample_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_GetMortgageDealRepresentativeExample_Response> {
    return this.httpClient.get(`/mortgage-service/cp/GetMortgageDealRepresentativeExample`, { params: request });
  }

  HTTP_CP_GetSmartSearchDealRepresentativeExample(
    request: HTTP_CP_GetSmartSearchDealRepresentativeExample_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_GetSmartSearchDealRepresentativeExample_Response> {
    return this.httpClient.get(`/mortgage-service/cp/GetSmartSearchDealRepresentativeExample`, { params: request });
  }

  HTTP_CP_ListMortgageDeals(
    request: HTTP_CP_ListMortgageDeals_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_ListMortgageDeals_Response> {
    return this.httpClient.get(`/mortgage-service/cp/ListMortgageDeals`, { params: request });
  }

  HTTP_CP_ListMortgages(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_ListMortgages_Response> {
    return this.httpClient.get(`/mortgage-service/cp/ListMortgages`, { params: request });
  }

  HTTP_CP_ListSmartSearchDeals(
    request: HTTP_CP_ListSmartSearchDeals_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_ListSmartSearchDeals_Response> {
    return this.httpClient.get(`/mortgage-service/cp/ListSmartSearchDeals`, { params: request });
  }

  HTTP_CP_ListSmartSearches(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_ListSmartSearches_Response> {
    return this.httpClient.get(`/mortgage-service/cp/ListSmartSearches`, { params: request });
  }

  HTTP_CP_MatchMortgageProducts(
    request: HTTP_CP_MatchMortgageProducts_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_MatchMortgageProducts_Response> {
    return this.httpClient.post(`/mortgage-service/cp/MatchMortgageProducts`, request, options);
  }

  HTTP_CP_UpdateMortgage_ForIrregularPayments(
    request: HTTP_CP_UpdateMortgage_ForIrregularPayments_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_Mortgage> {
    return this.httpClient.put(`/mortgage-service/cp/UpdateMortgage_ForIrregularPayments`, request, options);
  }

  HTTP_CP_UpdateMortgageComparisonSettings(
    request: HTTP_CP_UpdateMortgageComparisonSettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_MortgageComparisonSettings> {
    return this.httpClient.put(`/mortgage-service/cp/UpdateMortgageComparisonSettings`, request, options);
  }

  HTTP_CP_UpdateSmartSearch(request: HTTP_CP_UpdateSmartSearch_Request, options?: IRequestOptions): Observable<HTTP_CP_SmartSearch> {
    return this.httpClient.put(`/mortgage-service/cp/UpdateSmartSearch`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Extended (x) -------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_X_CalculateInterestRate_ForFullRepayment(
    request: HTTP_X_CalculateInterestRate_ForFullRepayment_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_X_CalculateInterestRate_ForFullRepayment_Response> {
    // FIXME #5860 NEW_URL_CONVENTION
    return this.httpClient.post(`/mortgage-service/x/calculate/interest-rate/ForFullRepayment`, request, options);
  }

  HTTP_X_CalculateInterestRate_ForInterestOnlyRepayment(
    request: HTTP_X_CalculateInterestRate_ForInterestOnlyRepayment_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_X_CalculateInterestRate_ForInterestOnlyRepayment_Response> {
    // FIXME #5860 NEW_URL_CONVENTION
    return this.httpClient.post(`/mortgage-service/x/calculate/interest-rate/ForInterestOnlyRepayment`, request, options);
  }

  HTTP_X_CalculateMonthlyPayments(
    request: HTTP_X_CalculateMonthlyPayments_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_X_CalculateMonthlyPayments_Response> {
    // FIXME #5860 NEW_URL_CONVENTION
    return this.httpClient.post(`/mortgage-service/x/calculate/payment`, request, options);
  }

  HTTP_X_CalculatePayMortgageFasterSavings(
    request: HTTP_X_CalculatePayMortgageFasterSavings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_X_CalculatePayMortgageFasterSavings_Response> {
    // FIXME #5860 NEW_URL_CONVENTION
    return this.httpClient.post(`/mortgage-service/x/calculate/pay-mortgage-faster-savings`, request, options);
  }

  HTTP_X_CompareMortgageProducts(
    request: HTTP_X_CompareMortgageProducts_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_X_CompareMortgageProducts_Response> {
    // FIXME #5860 NEW_URL_CONVENTION
    return this.httpClient.post(`/mortgage-service/x/mortgage-products/all/Compare`, request, options);
  }

  HTTP_X_GetMortgageProductRepresentativeExample(
    request: HTTP_X_GetMortgageProductRepresentativeExample_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_X_GetMortgageProductRepresentativeExample_Response> {
    // FIXME #5860 NEW_URL_CONVENTION
    return this.httpClient.post(`/mortgage-service/x/mortgage-products/one/representative-example`, request, options);
  }

  HTTP_X_ListLenders(request: HTTP_X_ListLenders_Request, options?: IRequestOptions): Observable<HTTP_X_ListLenders_Response> {
    // FIXME #5860 NEW_URL_CONVENTION
    return this.httpClient.get(`/mortgage-service/x/lenders`, { params: request });
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- INIT Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- PUBLIC Endpoints --------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  PUBLIC_UptimeCheck(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.get(`/mortgage-service/.public/UptimeCheck`, { params: request });
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- SPECIAL Endpoints -------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // TODO 2025/11/20 #5765 temporary endpoint to fix incorrect mortgage SVR

  // TODO #6091 Delete this after the CompanyMortgageComparisonSettings -> CompanySettingsForMortgageComparisons migration is complete
}
